import { useCallback, useRef } from 'react'
import { Col, Row } from 'react-grid-system'
import { NormalFormDateField, NormalFormNumberField, NormalFormSelectionField, NormalFormTextField } from '../molecules'
import { useUserLanguage } from '@/customHooks'
import { CreateRentChargeInput, RentChargeTypeOption } from '@/graphql/generated'
import textsData from '@/textData/CreateContractsTexts.json'

type AddRentchargeFormProps = {
  onChange: (data: CreateRentChargeInput) => void
  defaultData?: CreateRentChargeInput
}

const emptyData: CreateRentChargeInput = {
  rentChargeType: RentChargeTypeOption.RentIncome,
  description: '',
  amountValue: '',
  executionDate: new Date(),
}

export const AddRentChargeFormControlled = ({ onChange, defaultData }: AddRentchargeFormProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.rentCharges.form : textsData.en.rentCharges.form

  const rentDataRef = useRef<CreateRentChargeInput>(defaultData
    ? (
        {
          rentChargeType: defaultData.rentChargeType,
          description: defaultData.description,
          amountValue: defaultData.amountValue,
          executionDate: defaultData.executionDate,
        }
      )
    : emptyData
  )

  const rentChargeOptions = [
    {
      name: texts.option.option1,
      value: RentChargeTypeOption.RentIncome,
    },
    {
      name: texts.option.option2,
      value: RentChargeTypeOption.SecurityDeposit,
    },
    {
      name: texts.option.option3,
      value: RentChargeTypeOption.PetDeposit,
    }
  ]

  const onChangeHandle = useCallback((field: keyof CreateRentChargeInput, value: any) => {
    rentDataRef.current = {
      ...rentDataRef.current,
      [field]: value,
    }
    onChange(rentDataRef.current)
  }, [])

  return (
    <>
      <Row align='center'>
        <Col>
          <NormalFormSelectionField<RentChargeTypeOption>
            label={texts.rentChargeType.label}
            name={texts.rentChargeType.name}
            options={rentChargeOptions}
            onChange={(value) => onChangeHandle('rentChargeType', value)}
            required
            value={rentDataRef.current.rentChargeType}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormNumberField
            name="amount"
            label={texts.amount.label}
            onChange={(value) => onChangeHandle('amountValue', value)}
            required
            value={rentDataRef.current.amountValue}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormDateField
            label={texts.executionDate.label}
            name="executionDate"
            value={rentDataRef.current.executionDate instanceof Date ? rentDataRef.current.executionDate.toISOString() : rentDataRef.current.executionDate}
            onChange={(value) => onChangeHandle('executionDate', value)}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <NormalFormTextField
            name="description"
            label={texts.description.label}
            placeholder={texts.description.placeholder}
            onChange={(value) => onChangeHandle('description', value)}
            value={rentDataRef.current.description}
          />
        </Col>
      </Row>
    </>
  )
}